<template>
  <section ref="main" class="content">
    <div class="accessory-list-default" v-show="isEmpty">
      <img
        src="../../../static/img/icon_no_matching_result.svg"
        class="center-block accessory-list-no-matching-img"
      >
      <div class="text-center col-sm-6 col-sm-offset-3">
        <h4 class="page-404-tips">No update logs found.</h4>
      </div>
    </div>
    <div class="row">
      <div class="col-xs-12">
        <div
          class="box box-warning"
          v-for="(item, index) in list"
          v-bind:key="index"
        >
          <div class="logs-header">
            <h1 class="logs-date">{{item.date}}</h1>
            <h2 class="logs-version">
              (
              <strong>{{item.platform}}</strong>
              {{item.versionname}})
            </h2>
          </div>

          <div
            class="row logs-body data_aggregation_table_margin"
          >
            <table class="logs-table">
              <tbody>
                <tr>
                  <th>{{item.left.platformName}}</th>
                  <th>{{item.right.platformName}}</th>
                </tr>
                <tr>
                  <td
                    class="device-information-table-title table-width-quarter data_aggregation_title_color"
                  >
                    <pre
                      class="logs-content"
                      contenteditable
                      v-on:focusout="focusout(item.left, $event, 'developlog')"
                    >{{item.left.developlog}}</pre>
                  </td>
                  <td
                    class="device-information-table-title table-width-quarter data_aggregation_title_color"
                  >
                    <pre
                      class="logs-content"
                      contenteditable
                      v-on:focusout="focusout(item.right, $event, 'developlog')"
                    >{{item.right.developlog}}</pre>
                  </td>
                </tr>
                <tr>
                  <td
                    class="device-information-table-content table-width-quarter data_aggregation_title_color"
                  >
                    <pre
                      class="logs-content logs-note"
                      contenteditable
                      v-on:focusout="focusout(item.left, $event, 'releaselog')"
                    >{{item.left.releaselog}}</pre>
                  </td>
                  <td
                    class="device-information-table-content table-width-quarter data_aggregation_title_color"
                  >
                    <pre
                      class="logs-content logs-note"
                      contenteditable
                      v-on:focusout="focusout(item.right, $event, 'releaselog')"
                    >{{item.right.releaselog}}</pre>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import utils from "../../utils";
import api from "../../api";

export default {
  name: "update-logs",
  props: {
    path: {
      required: true
    },
    type: {
      required: true
    }
  },
  data() {
    return {
      list: [],
      currentDeviceListHeight: 0,
      page: 1,
      isAgentAdmin: utils.checkIsAppAdmin()
    };
  },
  computed: {
    isEmpty() {
      return !this.list.length;
    }
  },
  methods: {
    handleScroll(e) {
      var jqueryWindow = window.jQuery(window);
      var listNodeHeight = window.jQuery(this.$refs.main).height();
      var windowScrollTop = jqueryWindow.scrollTop();
      var windowHeight = jqueryWindow.height();
      if (
        this.currentDeviceListHeight < listNodeHeight &&
        windowScrollTop + windowHeight >= listNodeHeight
      ) {
        this.currentDeviceListHeight = windowScrollTop + windowHeight;
        this.fetch();
      }
    },
    async fetch() {
      const list = await api.post({
        path: `/updatelogs/${this.path}`,
        data: {
          appid: this.$route.query.appid,
          limit: 20,
          page: this.page
        }
      });
      const parsedList = [];
      list.forEach(item => {
        const { platform, versionname, date } = item;
        const prevItem = parsedList[parsedList.length - 1];
        const parsedItem = (() => {
          const isClients = this.type === "mobileclients";
          if (
            !prevItem ||
            prevItem.versionname !== versionname ||
            prevItem.date !== date
          ) {
            return {
              versionname,
              date,
              left: {
                versionname,
                date,
                platformName: isClients ? "iOS" : "Master",
                platform: isClients ? "IOS" : "Host machine"
              },
              right: {
                versionname,
                date,
                platformName: isClients ? "Android" : "Slave",
                platform: isClients ? "Android" : "Lower machine"
              }
            };
          }
          return prevItem;
        })();
        if (platform === "Lower machine" || platform === "Android") {
          Object.assign(parsedItem.right, item);
        } else {
          Object.assign(parsedItem.left, item);
        }
        if (prevItem !== parsedItem) {
          parsedList.push(parsedItem);
        }
      });
      this.list.push(...parsedList);
      this.page += 1;
    },
    focusout(item, ev, field) {
      const text = ev.currentTarget.innerText;
      const { id, versionname, platform, date } = item;
      api
        .post({
          path: "/updatelogs/patch",
          data: {
            appid: this.$route.query.appid,
            id,
            versionname,
            platform,
            date,
            [field]: text
          },
          noError: true
        })
        .catch(err => console.error(err));
    }
  },
  mounted() {
    this.fetch();
    window.addEventListener("scroll", this.handleScroll, false);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll, false);
  }
};
</script>

<style scope>
.logs-header {
  padding: 30px;
}
.logs-date {
  float: left;
  margin: 0;
  font-weight: bold;
  font-size: 16px;
}
.logs-version {
  float: left;
  margin: 0 0 0 15px;
  font-size: 16px;
}
.logs-table {
  width: 100%;
  margin: 0 15px 30px;
}
.logs-table th {
  padding-bottom: 10px;
}
.logs-table td {
  padding: 0;
}
.logs-content {
  width: 100%;
  min-height: 2em;
  display: block;
  margin: 0;
  border-color: white;
  background-color: white;
  font-size: 16px;
  white-space: pre-wrap;
  word-wrap: break-word;
}
.logs-note {
  color: #787878;
}
.logs-body {
  clear: both;
}
</style>



// WEBPACK FOOTER //
// UpdateLogs.vue?6faf21ba